import { chain } from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import { addToStartOfChain, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const SetBaseParameter = createChainHandler("SetBaseParameter", chain, props => {
    // `includeAttributes: ["includeOnProduct"]` needs to be sent to the "getProductByPath" service within the "LoadProductIfNeeded" handler chain.
    (props.parameter as any) = { includeAttributes: ["includeOnProduct"], ...props.parameter };
});

addToStartOfChain(chain, SetBaseParameter);
